import CONST from "./CONST";

const defaultState = {
    version: undefined,
    history: [
        {
            id: CONST.PAGE_FINANCES,
            skipped: false,
        }
    ],
    selections: {},
}

export default defaultState;
